import styled from 'styled-components';

export const Container = styled.div`
  margin-top: ${props => props.theme.spacing.lg};
  padding-top: ${props => props.theme.spacing.sm};
`;

export const Title = styled.h6`
  font-weight: ${props => props.theme.typography.weights.semibold};
  font-size: ${props => props.theme.typography.sizes.xs};
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${props => props.theme.colors.textSecondary};
  margin: 0;
  margin-right: 10px;
`;

export const Header = styled.header`
  background: ${props => props.theme.colors.grayLight} !important;
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.lg};
  margin-bottom: ${props => props.theme.spacing.lg};

  > div {
    background: ${props => props.theme.colors.grayLight} !important;
  }
`;

export const DeleteButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const BlcokSB = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${props => props.theme.spacing.lg};

  > div {
    width: 48%;
  }

  > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
  }
`;

export const InputArea = styled.input`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  width: 100%;
  min-height: 112px;
  resize: vertical;
  outline: none;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputText = styled.input`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputSelect = styled.select`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const CadVtm = styled.button`
  background: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.white};
  border: none;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.xl};
  font-weight: ${props => props.theme.typography.weights.semibold};
`;

export const EditVtm = styled.button`
  background: ${props => props.theme.colors.surface};
  color: ${props => props.theme.colors.textPrimary};
  border: 1px solid ${props => props.theme.colors.borderStrong};
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.xl};
  font-weight: ${props => props.theme.typography.weights.semibold};
`;
